import React from 'react';
import '../styles/alquiler.css';

const Alquiler = () => {
  const servicios = [
    {
      icon: 'computer',
      title: 'Computadores y Laptops',
      description: 'Equipos de última generación',
      details: 'Alquiler de computadores y laptops para eventos, capacitaciones y proyectos temporales.',
      highlight: 'Configuración personalizada incluida',
      tagline: 'Tecnología cuando la necesites'
    },
    {
      icon: 'devices',
      title: 'Periféricos y Accesorios',
      description: 'Todo lo que necesitas',
      details: 'Monitores, proyectores, impresoras y más accesorios disponibles para alquiler.',
      highlight: 'Instalación y soporte incluido',
      tagline: 'Complementa tu equipo'
    },
    {
      icon: 'security',
      title: 'Cámaras de Seguridad',
      description: 'Sistemas de vigilancia HD',
      details: 'Solución temporal de seguridad con cámaras y sistemas de monitoreo.',
      highlight: 'Instalación profesional incluida',
      tagline: 'Seguridad temporal'
    },
    {
      icon: 'router',
      title: 'Equipos de Red',
      description: 'Conectividad garantizada',
      details: 'Routers, switches y equipos de red para eventos y proyectos temporales.',
      highlight: 'Configuración de red incluida',
      tagline: 'Conecta tu evento'
    }
  ];

  return (
    <div className="alquiler-container">
      <div className="alquiler-header">
        <h1>Alquiler</h1>
        <p>Equipos tecnológicos para tus eventos y proyectos temporales</p>
      </div>

      <div className="alquiler-grid">
        {servicios.map((servicio, index) => (
          <div key={index} className="alquiler-card">
            <div className="card-icon">
              <span className="material-icons">{servicio.icon}</span>
            </div>
            <div className="card-content">
              <h3>{servicio.title}</h3>
              <p className="card-description">{servicio.description}</p>
              <p className="card-details">{servicio.details}</p>
              <p className="card-highlight">{servicio.highlight}</p>
              <p className="card-tagline">{servicio.tagline}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="alquiler-contacto">
        <h2>¿Necesitas equipos para tu evento?</h2>
        <div className="contacto-info">
          <a href="tel:+573112610669" className="info-item">
            <span className="material-icons">phone</span>
            <p>+57 311 261 0669</p>
          </a>
          <a href="https://wa.me/573112610669" target="_blank" rel="noopener noreferrer" className="info-item">
            <span className="material-icons">whatsapp</span>
            <p>+57 311 261 0669</p>
          </a>
          <div className="info-item">
            <span className="material-icons">schedule</span>
            <p>Lun - Vie: 8am - 6pm</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Alquiler; 